/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Role List</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="Serach：">
        <el-select size="small" clearable v-model="formInline.roleName" placeholder="Role Name">
          <el-option v-for="(item,i) in selectData" :key="i" :label="item.roleName" :value="item.roleName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" clearable v-model="formInline.roleAuthorization" placeholder="Role Authorization">
          <el-option v-for="(item,i) in selectData" :key="i" :label="item.roleAuthorization" :value="item.roleAuthorization"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" clearable v-model="formInline.editUser" placeholder="Modifier">
          <el-option v-for="(item,i) in selectData" :key="i" :label="item.editUser" :value="item.editUser"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Role Creation Time">
        <el-date-picker size="small" v-model="formInline.editTime" type="daterange" align="right" unlink-panels range-separator="To" start-placeholder="Start Date" end-placeholder="Ending Date" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Serach</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add Role</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :default-sort = "{prop: 'editTime', order: 'descending'}" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
      <el-table-column prop="roleName" label="Role Name" width="300">
      </el-table-column>
      <el-table-column prop="roleAuthorization" label="Role Authorization" width="300">
      </el-table-column>
      <el-table-column prop="editTime" label="Role Creation Time" width="300">
        <!-- <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <el-table-column prop="editUser" label="Role Creator" width="300">
      </el-table-column>
      <el-table-column align="center" fixed="right" label="Operation" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button :disabled="scope.row.roleAuthorization === 'Administrator'?true:false" size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">Delete</el-button>
          <el-button :disabled="scope.row.roleAuthorization === 'Administrator'?true:false" size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">Menu Permissions</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="140px" :model="editForm" ref="editForm" :rules="rules">
        <!-- <el-form-item label="系统编码" prop="systemNo">
          <el-input size="small" v-model="editForm.systemNo" auto-complete="off" placeholder="请输入系统编码"></el-input>
        </el-form-item> -->
        <el-form-item label="Role Name" prop="roleName">
          <el-input size="small" v-model="editForm.roleName" auto-complete="off" placeholder="Please enter a role name"></el-input>
        </el-form-item>
        <el-form-item label="Role Authorization" prop="roleAuthorization">
          <el-input :disabled="editForm.roleAuthorization === 'Administrator'?true:false" size="small" v-model="editForm.roleAuthorization" auto-complete="off" placeholder="Please enter the role authorization"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save</el-button>
      </div>
    </el-dialog>
    <!-- 菜单权限 -->
    <el-dialog title="Menu Permissions" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-tree ref="tree" default-expand-all="" :data="RoleRight" :props="RoleRightProps" :default-checked-keys="checkmenu" node-key="id" show-checkbox>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  roleSave,
  roleDelete,
  rolePwd,
  RoleRightTree,
  RoleRightSave
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      menuAccessObj: {
        dbName: 'menu',
        page: 1,
        roleId: ''
      },
      title: '',
      selectData: '',
      pickerOptions: {
        shortcuts: [{
          text: 'Latest week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      editForm: {
        roleAuthorization: '',
        roleName: ''
      },
      // rules 表单验证
      rules: {
        // systemNo: [
        //   { required: true, message: '请输入系统编码', trigger: 'blur' }
        // ],
        roleAuthorization: [
          { required: true, message: 'Please enter the role authorization', trigger: 'blur' }
        ],
        roleName: [
          { required: true, message: 'Please enter a role name', trigger: 'blur' }
        ]
      },
      formInline: {
        page: 1,
        dbName: 'role',
        roleName: '',
        roleAuthorization: '',
        editTime: '',
        editUser: ''
      },
      selectFormInline: {
        page: 1,
        dbName: 'role',
        roleName: '',
        roleAuthorization: '',
        editTime: '',
        editUser: ''
      },
      // 删除
      seletedata: {
        ids: ''
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        page: 1,
        size: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    roleList(this.selectFormInline)
      .then(res => {
        if (res.code === 201) {
          this.selectData = res.data
        }
      })
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取角色列表
    getdata(parameter) {
      // 获取角色列表数据
      roleList(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.listData = res.data;
            // 分页赋值
            this.pageparm.page = this.formInline.page
            this.pageparm.total = res.total;
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.page = this.formInline.page
            this.pageparm.total = res.total;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Failed to get the role list, please try again later！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      console.log(this.formInline);
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit'
        this.editForm.dbName = 'role';
        this.editForm.type = 'edit';
        this.editForm.roleId = row.id
        this.editForm.roleName = row.roleName
        this.editForm.roleAuthorization = row.roleAuthorization
        this.editForm.editTime = row.editTime;
      } else {
        var myDate = new Date();
        var hour = myDate.getHours();
        myDate.setHours(hour + 2)
        var time = myDate.toISOString()
        this.title = 'Add Role'
        this.editForm.dbName = 'role';
        this.editForm.type = 'create';
        this.editForm.roleAuthorization = '';
        this.editForm.roleName = '';
        this.editForm.menu = [];
        this.editForm.editTime = time;
        this.editForm.editUser = JSON.parse(localStorage.getItem('userdata'))._source.account;
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          console.log(this.editForm,'#########################');
          roleSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code === 201) {
                this.$message({
                  type: 'success',
                  message: 'The role is saved successfully！'
                })
                this.loading = true;
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Failed to save the role. Please try again later！')
            })
        } else {
          return false
        }
      })
    },
    // 删除角色
    deleteUser(index, row) {
      var deleteRole = {
        dbName : 'role',
        roleId : row.id
      }
      this.$confirm('Are you sure you want to delete?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          roleDelete(deleteRole)
            .then(res => {
              if (res.code === 201) {
                this.$message({
                  type: 'success',
                  message: 'The role has been deleted！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('Failed to delete the role. Please try again later！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled delete'
          })
        })
    },
    // 数据权限
    menuAccess: function(index, row) {
      console.log(row)
      this.menuAccessshow = true
      this.menuAccessObj.roleId = row.id
      RoleRightTree(this.menuAccessObj)
        .then(res => {
          if (res.code === 201) {
            this.$message({
              type: 'success',
              message: 'Permission obtained Successfully!'
            })
            this.checkmenu = row.menu[2];
            this.RoleRight = this.changeArr(res.data)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Failed to obtain permission. Please try again later！')
        })
    },
    // 选中菜单
    changemenu(arr) {
      console.log(arr,'@@@@@@@@@@@@@@@@@@@@@@@@');
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      this.checkmenu = change
    },
    // tree 递归
    changeArr(list) {
      var temptree = [],
        tree = [],
        items = []
      for (var i in list) {
        var trow = {
          id: list[i].menuid,
          name: list[i].menuname,
          children: []
        }
        for(var k in list[i].menus){
          var menustrow = {
            id: list[i].menus[k].menuid,
            name: list[i].menus[k].menuname,
            children: []
          }
          trow.children.push(menustrow)
        }
        tree.push(trow)
      }
      return tree
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        dbName: 'role',
        roleId: this.menuAccessObj.roleId,
        moduleIds: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = {parent:[],children:[],menu:[]};
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.menu.push(node[i].id)
          if(node[i].children.length !== 0){
            moduleIds.parent.push(node[i].id)
          }else{
            moduleIds.children.push(node[i].id)
          }
        }
        parm.moduleIds = JSON.stringify(moduleIds);
      }
      console.log(moduleIds)
      RoleRightSave(parm)
        .then(res => {
          console.log(parm);
          if (res.code === 201) {
            this.$message({
              type: 'success',
              message: 'Permission saved successfully!'
            })
            this.menuAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Permission save failed, please try again later！')
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Role.vue